module.exports = __webpack_public_path__ + "components/flag/static/square/nr-39c5b165ebfd2021383fd3bfab8483f1.svg";